import { Directive, HostListener, HostBinding } from '@angular/core';
import { NglPopoverTrigger } from './trigger';
var NglPopoverBehavior = (function () {
    function NglPopoverBehavior(trigger) {
        this.trigger = trigger;
        this.tabindex = 0;
    }
    NglPopoverBehavior.prototype.onMouseOver = function () {
        this.trigger.nglOpen = true;
    };
    NglPopoverBehavior.prototype.onMouseOut = function () {
        this.trigger.nglOpen = false;
    };
    NglPopoverBehavior.decorators = [
        { type: Directive, args: [{
                    selector: '[nglPopover][nglPopoverBehavior]',
                },] },
    ];
    /** @nocollapse */
    NglPopoverBehavior.ctorParameters = function () { return [
        { type: NglPopoverTrigger, },
    ]; };
    NglPopoverBehavior.propDecorators = {
        'tabindex': [{ type: HostBinding, args: ['attr.tabindex',] },],
        'onMouseOver': [{ type: HostListener, args: ['mouseenter',] }, { type: HostListener, args: ['focus',] },],
        'onMouseOut': [{ type: HostListener, args: ['mouseleave',] }, { type: HostListener, args: ['blur',] },],
    };
    return NglPopoverBehavior;
}());
export { NglPopoverBehavior };
;
//# sourceMappingURL=behavior.js.map